import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { ConfiguracoesAlimentadora, ConfiguracoesMPA } from 'app/interfaces';
import { ConfiguracoesService } from 'app/services';

@Component({
  selector: 'app-configuracoes-gerais',
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './configuracoes-gerais.component.html',
  styleUrl: './configuracoes-gerais.component.css'
})
export class ConfiguracoesGeraisComponent implements OnInit {
  @Output() trocarTela: EventEmitter<string> = new EventEmitter<string>();
  @Output() mostrarDialogLogin: EventEmitter<void> = new EventEmitter<void>();
  public mpaConfig!: ConfiguracoesMPA;
  public alimentadoraConfig!: ConfiguracoesAlimentadora;
  public configuracoes!: {
    titulo: string,
    tela: string,
    descricaoIcone: string,
    descricao: string,
    desabilitada: boolean,
  }[];

  public temAlimentadora: boolean = false;
  public falhaAlertaDisponivel: boolean = false;

  constructor(private readonly configuracoesService: ConfiguracoesService) { }

  ngOnInit(): void {
    this.iniciarConfiguracoes();
    this.hasAcessoAlimentadora();
    this.temFalhaAlerta();
  }

  public irParaTelaConfig(tela: string): void {
    this.trocarTela.emit(`configuracoes/${tela}`);
  }

  public pedirLoginParaConfiguracaoDeLicenca(): void {
    this.mostrarDialogLogin.emit();
  }

  public iniciarConfiguracoes(): void {
    const baseKey = 'COMPONENTS.AGVIEW_CONNECT.MENU_CONFIGURACOES';

    this.configuracoes = [
      {
        titulo: `${baseKey}.OPERACAO.TITULO`,
        descricaoIcone: `${baseKey}.OPERACAO.ICONE`,
        tela: 'operacao',
        descricao: `${baseKey}.OPERACAO.DESCRICAO`,
        desabilitada: false
      },
      {
        titulo: `${baseKey}.LICENCA.TITULO`,
        descricaoIcone: `${baseKey}.LICENCA.ICONE`,
        tela: 'licenca',
        descricao: `${baseKey}.LICENCA.DESCRICAO`,
        desabilitada: false
      },
      {
        titulo: `${baseKey}.ALIMENTADORA.TITULO`,
        descricaoIcone: `${baseKey}.ALIMENTADORA.ICONE`,
        tela: 'alimentadora',
        descricao: `${baseKey}.ALIMENTADORA.DESCRICAO`,
        desabilitada: !this.temAlimentadora
      },
      {
        titulo: `${baseKey}.FALHA_ALERTA.TITULO`,
        descricaoIcone: `${baseKey}.FALHA_ALERTA.ICONE`,
        tela: 'falha-alerta',
        descricao: `${baseKey}.FALHA_ALERTA.DESCRICAO`,
        desabilitada: !this.falhaAlertaDisponivel
      }
    ];
  }

  public hasAcessoAlimentadora(): void {
    this.configuracoesService.obterPorEntidadeWebsocket('License')
    .subscribe(() => {
      const license: string = this.configuracoesService.obterPorEntidade('License')?.licenseCode!
      this.temAlimentadora = license.includes('A1');
    });
    ;
  }

  public temFalhaAlerta(): void {
    this.configuracoesService.obterPorEntidadeWebsocket('License')
    .subscribe(() => {
      const license: string = this.configuracoesService.obterPorEntidade('License')?.licenseCode!
      this.falhaAlertaDisponivel = !license.includes('S0') || !license.includes('L0');
    });
    ;
  }
}
